import { render, staticRenderFns } from "./FormIncomeProofs.vue?vue&type=template&id=755db848&"
import script from "./FormIncomeProofs.vue?vue&type=script&lang=js&"
export * from "./FormIncomeProofs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports